import { lazy, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import US from '../assets/images/US.svg';
import GA from '../assets/images/scotland.png';
import WE from '../assets/images/Flag_of_Wales.png';
import IR from '../assets/images/ireland.png';
import EN from '../assets/images/eng.png';

import AccountIcon from '../assets/images/account.png';
import CartIcon from '../assets/images/cart.png';
import { getTokenData,isUkCountry } from "../helpers/userData";
import { useTranslation } from 'react-i18next';  // Import the useTranslation hook

const Search = lazy(() => import("./Search"));

const Header = (props) => {
  const flagImages = {
    'GB-EN': EN,  
    'GB-NIR': IR,  
    'GB-SCT': GA,  
    'GB-WLS': WE,  
  };

  const [isUk, setIsUk] = useState(false);
  const [countryFlag, setCountryFlag] = useState(flagImages['GB-EN']); // Default flag is set to 'GB-EN'
  const { t, i18n } = useTranslation();  // Destructure to access translation and change language
  // const token = getTokenData();
  const [tokenState, setToken] = useState(false);
  useEffect(() => {
    checkCountry();
    checkToken();
  }, []);

  const { storeInfo, qty } = props;

  const checkCountry = async () => {
    const result = await isUkCountry();
    setIsUk(result); 
  };

  const checkToken = async () => {
  //  const result = await isUkCountry();
    const token = getTokenData();
    setToken(token); 
  };


  // Function to handle language change
  const changeFlag = (country_code) => {
    props.onLanguageChange(country_code);
    setCountryFlag(flagImages[country_code]);  // Update the flag state
  };

  return (
    <header className="py-1 border-bottom" style={{ backgroundColor: storeInfo.headerColor ?? '#FFFFFF' }}>
      <div className="container">
        <div className="row g-0">
          <div className="col-md-3 col-3 m-0 h--100 d-flex align-items-center">
            <h3 className="fw-bold text-lg-start text-center m-0">
              <Link to="/" className="text-decoration-none" title={storeInfo.storeDetails.organizationName} style={{ color: storeInfo.buttonTextColor ?? '#FFFFFF' }}>
                {storeInfo.storeLogo ? <img src={storeInfo.storeLogoUrl} width='100' alt={storeInfo.storeDetails.organizationName} className='storeLogo'/> : <div className="py-3">{storeInfo.storeDetails.organizationName}</div>}
              </Link>
            </h3>
          </div>
          <div className="col-md-9 col-9">
            <div className={`d-flex justify-content-end align-items-center h-100 ${isUk ? 'xs-pr-4rem' : ''}`}>
              <div className="d-none d-lg-block"><Search /></div>
              <div className="dropdown d-block d-lg-none">
                <button className="btn btn-secondary bg-white text-dark dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="bi bi-search"></i>
                </button>
                <ul className="dropdown-menu searchDropdown p-0" aria-labelledby="dropdownMenuButton1">
                  <Search />
                </ul>
              </div>
              <div className="position-relative d-inline mx-lg-4 mx-2">
                <Link to="/cart">
                  <img src={CartIcon} alt='icon' />
                  <div className="position-absolute top-0 start-100 translate-middle badge bg-danger rounded-circle">
                    {qty ?? 0}
                  </div>
                </Link>
              </div>
              <div className="btn-group ms-lg-0 ms-2">
                <Link to={tokenState && tokenState !== null ? "/account/dashboard" : "/account/signin"}>
                  <img src={AccountIcon} alt='icon' />
                </Link>
              </div>
              { isUk && (
                <div className='langDropdownContainer me-3 ps-lg-3 ps-0 position-absolute right-0 float-end'>
                  <div className="PhoneInput border br--5">
                    <div className="PhoneInputCountry px-1">
                      <select 
                        aria-label="Phone number country" 
                        className="form-control countryDropdown PhoneInputCountrySelect" 
                        onChange={(e) => changeFlag(e.target.value)} 
                        value={Object.keys(flagImages).find(key => flagImages[key] === countryFlag)} // Sync the select value with countryFlag state
                      >
                        <option value="GB-EN">English</option>
                        <option value="GB-NIR">Irish Gaelic</option>
                        <option value="GB-SCT">Scottish Gaelic</option>
                        <option value="GB-WLS">Welsh</option>
                      </select>
                      <div className="PhoneInputCountryIcon PhoneInputCountryIcon--border">
                        <img className="PhoneInputCountryIconImg" alt="flag" role="presentation" src={countryFlag} />
                      </div>
                      <div className="PhoneInputCountrySelectArrow ps-1">
                        <i className="bi bi-chevron-down text-white fs-10" />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
